<div class="role-form-container">
  <!-- Header -->
  <div class="form-header">
    <button mat-icon-button (click)="goBack()" class="back-button" matTooltip="Retour">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1>{{ getPageTitle() }}</h1>
  </div>

  <!-- Barre de progression -->
  @if (loading || submitting) {
    <mat-progress-bar mode="indeterminate" class="loading-bar"></mat-progress-bar>
  }

  <!-- Formulaire -->
  <div class="form-content">
    <mat-card class="form-card">
      <form [formGroup]="roleForm" (ngSubmit)="onSubmit()">

        <!-- Section: Informations de base -->
        <div class="form-section">
          <div class="section-header">
            <mat-icon class="section-icon">info</mat-icon>
            <h2>Informations de base</h2>
          </div>

          <div class="form-row">
            <!-- Type de rôle -->
            <!-- Type de rôle -->
            @if (!isEditMode) {
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Type de rôle</mat-label>
                <mat-select formControlName="roleType">
                  <!-- Trigger personnalisé : affiche uniquement le libellé court -->
                  <mat-select-trigger>
                    {{ roleForm.get('roleType')?.value === 'realm' ? 'Realm rôle' : 'Client rôle' }}
                  </mat-select-trigger>
                  <!-- Options avec icônes et descriptions -->
                  <mat-option value="realm">
                    <div class="role-type-option">
                      <mat-icon>admin_panel_settings</mat-icon>
                      <div>
                        <div class="option-title">Rôle Realm</div>
                        <div class="option-description">Rôle global au niveau du realm</div>
                      </div>
                    </div>
                  </mat-option>
                  <mat-option value="client">
                    <div class="role-type-option">
                      <mat-icon>apps</mat-icon>
                      <div>
                        <div class="option-title">Rôle Client</div>
                        <div class="option-description">Rôle spécifique à une application</div>
                      </div>
                    </div>
                  </mat-option>
                </mat-select>
                @if (hasError('roleType')) {
                  <mat-error>
                    {{ getErrorMessage('roleType') }}
                  </mat-error>
                }
              </mat-form-field>
            }
          </div>

          <div class="form-row">
            <!-- Client (si rôle client) -->
            @if (!isRealmRole) {
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Application cliente</mat-label>
                <mat-select formControlName="clientId" [disabled]="isEditMode">
                  @for (client of clients; track client) {
                    <mat-option [value]="client.id">
                      <div class="client-option">
                        <div class="client-option-name">{{ client.name || client.clientId }}</div>
                        <div class="client-option-id">{{ client.clientId }}</div>
                      </div>
                    </mat-option>
                  }
                </mat-select>
                @if (!isEditMode) {
                  <mat-hint>Sélectionnez l'application pour laquelle créer ce rôle</mat-hint>
                }
                @if (hasError('clientId')) {
                  <mat-error>
                    {{ getErrorMessage('clientId') }}
                  </mat-error>
                }
              </mat-form-field>
            }
          </div>

          <div class="form-row">
            <!-- Nom du rôle -->
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Nom du rôle (identifiant technique)</mat-label>
              <input matInput formControlName="name" placeholder="ex: admin, user, manager" autocomplete="off"
                [readonly]="isEditMode">
                <mat-icon matSuffix>label</mat-icon>
                @if (!isEditMode) {
                  <mat-hint>Uniquement lettres, chiffres, tirets et underscores</mat-hint>
                }
                @if (isEditMode) {
                  <mat-hint class="edit-hint">
                    <mat-icon class="hint-icon">lock</mat-icon>
                    Le nom ne peut pas être modifié
                  </mat-hint>
                }
                @if (hasError('name')) {
                  <mat-error>
                    {{ getErrorMessage('name') }}
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- NOUVEAU CHAMP : Libellé (title) -->
            <div class="form-row">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Libellé (affichage)</mat-label>
                <input matInput formControlName="title" placeholder="Libellé convivial du rôle" maxlength="100">
                <mat-icon matSuffix>title</mat-icon>
                <mat-hint>Ce libellé sera affiché à la place du nom dans l'interface</mat-hint>
                @if (hasError('title')) {
                  <mat-error>
                    {{ getErrorMessage('title') }}
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="form-row">
              <!-- Description -->
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Description</mat-label>
                <textarea matInput formControlName="description" placeholder="Décrivez le rôle et ses permissions..."
                rows="3" maxlength="255"></textarea>
                <mat-icon matSuffix>description</mat-icon>
                <mat-hint align="end">
                  {{ roleForm.get('description')?.value?.length || 0 }} / 255
                </mat-hint>
                @if (hasError('description')) {
                  <mat-error>
                    {{ getErrorMessage('description') }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>

          <!-- Section: Options avancées -->
          <!-- <div class="form-section">
          <div class="section-header">
            <mat-icon class="section-icon">settings</mat-icon>
            <h2>Options avancées</h2>
          </div>

          <div class="form-row">
            <div class="checkbox-field">
              <mat-checkbox formControlName="composite">
                Rôle composite
              </mat-checkbox>
              <p class="field-description">
                <mat-icon class="info-icon">info</mat-icon>
                Un rôle composite peut contenir d'autres rôles
              </p>
            </div>
          </div>
        </div> -->

        <!-- Actions -->
        <div class="form-actions">
          <button mat-button type="button" (click)="goBack()" [disabled]="submitting" class="cancel-button">
            <mat-icon>close</mat-icon>
            Annuler
          </button>

          <button mat-raised-button color="primary" type="submit" [disabled]="roleForm.invalid || submitting"
            class="submit-button">
            @if (!submitting) {
              <mat-icon>{{ isEditMode ? 'save' : 'add' }}</mat-icon>
            }
            @if (submitting) {
              <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
            }
            {{ getSubmitButtonLabel() }}
          </button>
        </div>
      </form>
    </mat-card>

    <!-- Carte d'information -->
    @if (!isEditMode) {
      <mat-card class="info-card">
        <div class="info-header">
          <mat-icon class="info-icon-large">help_outline</mat-icon>
          <h3>À propos des rôles</h3>
        </div>
        <div class="info-content">
          <div class="info-item">
            <mat-icon class="info-bullet">fiber_manual_record</mat-icon>
            <div>
              <strong>Rôles Realm</strong>
              <p>Rôles globaux disponibles pour tous les clients du realm</p>
            </div>
          </div>
          <div class="info-item">
            <mat-icon class="info-bullet">fiber_manual_record</mat-icon>
            <div>
              <strong>Rôles Client</strong>
              <p>Rôles spécifiques à une application cliente</p>
            </div>
          </div>
          <div class="info-item">
            <mat-icon class="info-bullet">fiber_manual_record</mat-icon>
            <div>
              <strong>Rôles Composites</strong>
              <p>Peuvent contenir d'autres rôles pour une gestion simplifiée</p>
            </div>
          </div>
        </div>
      </mat-card>
    }
  </div>
</div>